export default {
  contracts: [],
  contract: {}
}
